import React from 'react';
import {Box, Button, Flex, Text} from '@chakra-ui/react';
import BottomModalSheet from '../../../components/Modals/BottomModalSheet';
import {TextG12, TextG14, TextG18} from '../../../components/typography';
import { BlueButton } from '../../../components/button';

interface RSVPRestrictionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpgradeClick: () => void;
}

const RSVPRestrictionModal = ({isOpen, onClose, onUpgradeClick}: RSVPRestrictionModalProps) => {
  return (
    <BottomModalSheet openModal={isOpen} onModalClose={onClose}>
      <Box px={4} py={4} textAlign="center">
        <TextG18 fontWeight="700" mb={3}>
          RSVP to Insider Events
        </TextG18>

        <TextG14 mb={4} color="gray.600">
          This event is exclusive to Walkabout Local Insiders Club members. Join the club to RSVP to
          this event and unlock access to exclusive local experiences, perks, and a vibrant
          community of neighbors.
        </TextG14>

        <Flex direction="column" gap={3} mt={4}>
          <BlueButton onClick={onUpgradeClick}>
            Join the Local Insiders Club
          </BlueButton>

          <Button variant="ghost" size="md" onClick={onClose}>
            <TextG12 color="gray.500">Maybe Later</TextG12>
          </Button>
        </Flex>
      </Box>
    </BottomModalSheet>
  );
};

export default RSVPRestrictionModal;
